import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/admin/Dev.js"

import SpriteAnimation from "@frog/source/juice/utility/SpriteAnimation.js"
import "@frog/source/views/components/UnitSprite.less"

import unitsprites from "@frog/source/data/unitsprites.js"
import units from "@frog/source/data/units.js"
import games from "@frog/source/data/games/index.js"

const DEFAULT_AFFILIATION = "bad"
const DEFAULT_FACE_KEY = "human"

export default class UnitSprite {
    render() {
        if(this.props.unit == undefined) return
        if(this.props.unit.type != undefined) {
            return(
                <div class="PlaceholderSpot"/>
            )
        }

        if(this.imageUrl != undefined) {
            return (
                <div class="UnitSprite" isGrayscaled={this.props.isGrayscaled}
                    isHighlighted={this.props.isHighlighted}
                    style={{"background-image": "url(" + this.imageUrl + ")"}}/>
            )
        }
        return (
            <div class="UnitSprite" isGrayscaled={this.props.isGrayscaled}>
                <div class="Body" style={{
                    "background-image": this.bodyUrl() && "url(" + this.bodyUrl() + ")",
                    "animation-name": this.animationName,
                    "animation-delay": this.animationDelay,
                }}/>
                <div class="Face" style={{
                    "background-image": this.faceUrl() && "url(" + this.faceUrl() + ")",
                    "animation-name": this.animationName,
                    "animation-delay": this.animationDelay,
                }}/>
                <div class="Decal" style={{
                    "background-image": this.decalUrl() && "url(" + this.decalUrl() + ")",
                    "animation-name": this.animationName,
                    "animation-delay": this.animationDelay,
                }}/>
                <div class="Weapon" isHidden={this.props.unit.affiliation == "none"} style={{
                    "background-image": this.weaponUrl() && "url(" + this.weaponUrl() + ")",
                    "animation-name": this.animationName,
                    "animation-delay": this.animationDelay,
                }}/>
            </div>
        )
    }
    get animationName() {
        if(App.game.configuration.squigglevision == true
        && Dev.inProtoMode != true
        && this.props.abortSquigglevision != true) {
            return "squigglevision"
        }
    }
    get animationDelay() {
        if(this.props.unit.affiliation == "bad") {
            return "0s"
        } else {
            return "0.5s"
        }
    }
    getUnitProperty(property) {
        let result = undefined
        if(this.props.unit.jobKey != undefined) {
            result = units[this.props.unit.jobKey][property]
        } else {
            if(this.props.unit.randomJobKey != undefined) {
                let possibleJobKeys = []
                this.props.unit.randomJobKey.split(",").forEach((jobKey) => {
                    jobKey = jobKey.trim()
                    possibleJobKeys.push(jobKey)
                })
                const randomizedJobKey = possibleJobKeys[Math.floor(Date.now()/1000) % possibleJobKeys.length]
                result = units[randomizedJobKey][property]
            }
        }
        const partyUnit = games[App.game.slug].player.party.units[this.props.unit.key]
        if(partyUnit != undefined) {
            if(partyUnit.jobKey != undefined) result = units[partyUnit.jobKey][property]
            result = partyUnit[property]
        }
        return result
    }
    bodyUrl() {
        let protoBodyKey = undefined
        if(Dev.inProtoMode == true) {
            protoBodyKey = this.getUnitProperty("bodyKey")
        }
        return this.props.unit.body || unitsprites.bodies[protoBodyKey || this.props.unit.bodyKey || this.props.unit.affiliation || DEFAULT_AFFILIATION]
    }
    faceUrl() {
        let protoFace = undefined
        let protoFaceKey = undefined
        if(Dev.inProtoMode == true) {
            protoFace = this.getUnitProperty("face")
            protoFaceKey = this.getUnitProperty("faceKey")
        }
        return this.props.unit.face || protoFace || unitsprites.faces[this.props.unit.faceKey || protoFaceKey || DEFAULT_FACE_KEY]
    }
    decalUrl() {
        if(this.props.unit.affiliation == "none") {
            return unitsprites.decals["jail"]
        }
        if(this.getUnitProperty("decalImageKey") != undefined) {
            return unitsprites.decals[this.getUnitProperty("decalImageKey")]
        }
    }
    weaponUrl() {
        let protoWeaponImageKey = undefined
        if(Dev.inProtoMode == true) {
            protoWeaponImageKey = this.getUnitProperty("weaponImageKey")
        }
        return unitsprites.weapons[protoWeaponImageKey || this.props.unit.weaponImageKey]
    }
    get imageUrl() {
        const unit = this.props.unit

        if(unit.sprites == undefined) return

        if(unit.affiliation == "good"
        && unit.energy["invoke skill"] != false) {
            if(unit.sprites?.moving != undefined
            && App.game.chapter.selection.selectedUnitKey == unit.key) {
                return SpriteAnimation.getImage({
                    "animation": unit.sprites.moving
                })
            }

            if(unit.sprites?.ready != undefined
            && App.game.chapter.selection.hoveredUnitKey == unit.key) {
                return SpriteAnimation.getImage({
                    "animation": unit.sprites.ready,
                    "startTimestamp": App.game?.chapter?.selection?.hoveredTimestamp
                })
            }
        }

        if(unit.sprites?.idle != undefined) {
            return SpriteAnimation.getImage({
                "animation": unit.sprites.idle
            })
        }
        if(unit.sprites.static != undefined) {
            return unit.sprites.static
        }
    }
    get paletteKey() {
        if(this.props.unit.affiliation == "bad") {
            return "red"
        } else {
            return "blue"
        }
    }
}
